module.exports = __webpack_public_path__ + "static/media/ninety.bcc5a82f.svg";